import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { getSubdomainSlug } from './subdomain'

/**
 * Unified tenant slug resolver hook.
 *
 * Priority:
 *   1. Subdomain slug (e.g., fusion-tarrazu.noiza.estrategiasdigitalesaz.com)
 *   2. Path-based slug from React Router params (e.g., /:slug or /admin/:slug)
 *   3. Explicit override (if passed as argument)
 *
 * Usage:
 *   const slug = useTenantSlug()           // auto-detect
 *   const slug = useTenantSlug('override') // explicit
 */
export function useTenantSlug(explicitSlug?: string): string | undefined {
  const params = useParams<{ slug: string }>()

  return useMemo(() => {
    // 1. Explicit override takes priority
    if (explicitSlug) return explicitSlug

    // 2. Subdomain slug
    const subdomainSlug = getSubdomainSlug()
    if (subdomainSlug) return subdomainSlug

    // 3. Path-based slug from router params
    return params.slug
  }, [explicitSlug, params.slug])
}
